const browser = {
  /**
   * 離開頁面前顯示提示
   * @param {*} e
   */
  leavePageAlert(e) {
    e.preventDefault();
    e.returnValue = '';
  },
  // 禁止瀏覽器“回上頁”
  preventBackPrevPage() {
    history.pushState(history.state, null, location.href);
    window.onpopstate = function() {
      history.go(1);
    };
  },
};

export default browser;
